export var MediaType;
(function (MediaType) {
    MediaType["TXT"] = "text/plain";
    MediaType["PDF"] = "application/pdf";
    MediaType["DOC"] = "application/msword";
    MediaType["DOCX"] = "application/vnd.openxmlformats-officedocument.wordprocessingml.document";
    MediaType["PNG"] = "image/png";
    MediaType["JPG"] = "image/jpeg";
})(MediaType || (MediaType = {}));
export var DocStatus;
(function (DocStatus) {
    DocStatus["PendingStatus"] = "PENDING";
    DocStatus["AvailableStatus"] = "AVAILABLE";
    DocStatus["ErrorStatus"] = "ERROR";
})(DocStatus || (DocStatus = {}));
export var OwnerType;
(function (OwnerType) {
    OwnerType["OwnerTraveler"] = "TRAVELER";
    OwnerType["OwnerPartner"] = "PARTNER";
    OwnerType["OwnerMatch"] = "TRIP_MATCH";
    OwnerType["OwnerInternal"] = "INTERNAL";
})(OwnerType || (OwnerType = {}));
export var DocumentType;
(function (DocumentType) {
    DocumentType["DocumentGeneral"] = "GENERAL";
    DocumentType["DocumentSampleItinerary"] = "SAMPLE_ITINERARY";
    DocumentType["DocumentItinerary"] = "ITINERARY";
})(DocumentType || (DocumentType = {}));
